import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedProductType } from 'contracts/ProductTypes';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_PRODUCTTYPES_',
  }
);

export interface ListProductTypesState {
  data: ListedProductType[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListProductTypesRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedProductType[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListProductTypesState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListProductTypesState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListProductTypesState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListProductTypesState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListProductTypesState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listProductTypes = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListProductTypesTypes = Types;
export const ListProductTypesActions = Creators;
